import VueRouter, { RouteConfig } from 'vue-router'
import { VacationHomeworkReportScope } from 'kuaidong-model'

const Report = () => import('../views/vacation-homework/Report.vue')

const reportRoute: RouteConfig = {
  path: '/vacation-homework-report',
  name: 'vacation_homework_report',
  component: Report,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: route.query.clazzId ? Number(route.query.clazzId) : null,
  }),
  meta: {
    title: '校园寒假作业报告',
  },
}

export default [reportRoute]

export function navigateToVacationHomeworkReport(
  router: VueRouter,
  scope = VacationHomeworkReportScope.AllClazzes,
  clazzId: number | null = null,
  clazzName = ''
) {
  router.push({
    name: reportRoute.name,
    query: { scope, clazzId: clazzId ? String(clazzId) : undefined, clazzName: clazzName || undefined },
  })
}
